// Small accessor to get the i18n instance after setup in main.js
// We avoid import cycles by setting it once when initialized.
let _i18n = null;
export function setI18n(i18n) {
	_i18n = i18n;
}
export function getI18n() {
	return _i18n;
}
